import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import ModalContainer from '../ModalContainer';

// Actions
import {
  hideModal,
} from '../../../actions/modal';

class OnboardingSuccessTrialModal extends Component {

  render() {
    return (
      <ModalContainer
        modalExit={true}
        optionalClasses="onboarding-success-trial"
      >
        <header>
          <h2>
            You're in the Game!
          </h2>
          <div className="video-player">
            <iframe
              src="https://player.vimeo.com/video/306424794"
              width="640"
              height="360"
              frameBorder="0"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowFullScreen="true"
              title="Locker Linked Welcome Video"
            ></iframe>
          </div>
          <h3>
            Congratulations, your account is now active.
          </h3>
          <p>
            Thank you for joining Locker Linked. With your Free Trial you can:
          </p>
          <div className="trial-features-container">
            <ul>
              <li>
                Create your premier player profile to share and promote to college coaches.
              </li>
              <li>
                Gain access to our extensive college coaches’ database.
                <br/>
                <em>Your free trial will limit you to view direct contact information for a total of 5 college coaches (with paid upgrade you’ll have unlimited access).</em>
              </li>
              <li>
                Access our comprehensive resource library to help you maximize your recruiting journey.
              </li>
            </ul>
          </div>
          <p>
            At the end of your free trial, we’re confident that Locker Linked will be your go-to platform for directly promoting yourself to college coaches.
          </p>
          <p className="note">
            *You can upgrade your profile at any time.
          </p>
        </header>
        <a
          onClick={() => this.props.hideModal()}
          className="cta invert full-width"
        >
          Get Started
        </a>
      </ModalContainer>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideModal: modalType => {
      dispatch(hideModal())
    },
  }
}

export default connect(
  null,
  mapDispatchToProps
)(OnboardingSuccessTrialModal)



// WEBPACK FOOTER //
// ./src/components/Modals/Onboarding/OnboardingSuccessTrialModal.js